"use strict";

/*
 * Section Benefits: colour-swatch slider with an optional Traditional/Rollaway
 * toggle. Each [data-line-panel] holds its own thumbnail + main swiper pair;
 * hidden panels initialise lazily on first reveal because Swiper can't measure
 * inside display:none.
 */
(function () {
  if (customElements.get("s-benefits")) return;

  function isThumbSliderScrollable(thumbs) {
    var total = Array.prototype.reduce.call(thumbs.slides, function (sum, slide) {
      return sum + slide.offsetWidth;
    }, 0);
    return total > thumbs.el.offsetWidth;
  }

  // When every dot fits, freeze the thumb slider so the row sits still and
  // doesn't drag; when it overflows, let it free-scroll.
  function updateThumbSliderState(thumbs) {
    if (isThumbSliderScrollable(thumbs)) {
      thumbs.params.freeMode = true;
      thumbs.params.allowTouchMove = true;
      thumbs.el.classList.remove("is-static");
    } else {
      thumbs.params.freeMode = false;
      thumbs.params.allowTouchMove = false;
      thumbs.el.classList.add("is-static");
    }
    thumbs.update();
  }

  customElements.define("s-benefits", class extends HTMLElement {
    connectedCallback() {
      this._pairs = new Map();
      this._panels = Array.prototype.slice.call(this.querySelectorAll("[data-line-panel]"));
      if (!this._panels.length) return;

      var self = this;
      var visible = this._panels.filter(function (panel) { return !panel.hidden; })[0] || this._panels[0];
      this._initPanel(visible);

      this.querySelectorAll("[data-line-toggle]").forEach(function (button) {
        button.addEventListener("click", function () {
          self._showLine(button.dataset.lineToggle);
        });
      });

      this._onResize = function () {
        self._pairs.forEach(function (pair, panel) {
          if (!panel.hidden) updateThumbSliderState(pair.thumbs);
        });
      };
      window.addEventListener("resize", this._onResize);
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this._onResize);
    }

    _initPanel(panel) {
      if (this._pairs.has(panel)) return this._pairs.get(panel);
      var thumbEl = panel.querySelector(".js-benefits__thumbnail");
      var mainEl = panel.querySelector(".js-benefits__main-slider");
      if (!thumbEl || !mainEl) return null;

      var thumbs = new Swiper(thumbEl, {
        spaceBetween: 16,
        slidesPerView: "auto",
        freeMode: true,
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
        breakpoints: {
          768: { spaceBetween: 24 }
        }
      });

      var main = new Swiper(mainEl, {
        spaceBetween: 0,
        navigation: true,
        autoplay: { delay: 5000, disableOnInteraction: false },
        observer: true,
        observeParents: true,
        thumbs: { swiper: thumbs }
      });

      thumbs.slides.forEach(function (slide, index) {
        slide.addEventListener("click", function () {
          main.slideTo(index);
        });
      });

      main.on("slideChange", function () {
        if (!isThumbSliderScrollable(thumbs)) return;
        var active = thumbs.slides[main.activeIndex];
        if (!active) return;
        var slideRect = active.getBoundingClientRect();
        var listRect = thumbs.el.getBoundingClientRect();
        if (slideRect.left < listRect.left || slideRect.right > listRect.right) {
          active.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
        }
      });

      var pair = { thumbs: thumbs, main: main };
      this._pairs.set(panel, pair);
      updateThumbSliderState(thumbs);
      return pair;
    }

    _showLine(line) {
      var self = this;

      this.querySelectorAll("[data-line-toggle]").forEach(function (button) {
        var active = button.dataset.lineToggle === line;
        button.classList.toggle("is-active", active);
        button.setAttribute("aria-selected", active ? "true" : "false");
      });

      this._panels.forEach(function (panel) {
        var show = panel.dataset.linePanel === line;
        panel.hidden = !show;
        if (show) {
          var pair = self._initPanel(panel);
          if (!pair) return;
          // Refresh now and once more after layout settles: a swiper revealed
          // from display:none can carry a stale zero/shrunk measurement.
          var refresh = function () {
            pair.thumbs.update();
            pair.main.update();
            updateThumbSliderState(pair.thumbs);
          };
          refresh();
          window.requestAnimationFrame(refresh);
          if (pair.main.autoplay) pair.main.autoplay.start();
        } else {
          var hiddenPair = self._pairs.get(panel);
          if (hiddenPair && hiddenPair.main.autoplay) hiddenPair.main.autoplay.stop();
        }
      });

      var link = this.querySelector("[data-line-link]");
      if (link) {
        var url = link.dataset[line + "Url"] || link.dataset.traditionalUrl;
        var text = link.dataset[line + "Text"] || link.dataset.traditionalText;
        if (url) link.setAttribute("href", url);
        var label = link.querySelector("[data-line-link-text]");
        if (label && text) label.textContent = text;
      }
    }
  });
})();
